export enum RadioValue {
  CreditNote = 'credit-note',
  VoidInvoice = 'void-invoice',
  VoidAndDuplicateInvoice = 'void-and-duplicate-invoice',
}
